"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const media_1 = require("./media");
const upload_1 = require("./media/upload");
const ImageSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { schema } = props;
    const { rootPath, maxHeight } = schema;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
            react_1.default.createElement(upload_1.Upload, Object.assign({}, registerProps, { value: value, rootPath: rootPath, hasError: fieldState.invalid, accept: "image/*" }))),
        react_1.default.createElement(media_1.Image, { style: { border: "1px solid #ccc", maxHeight }, src: value })));
};
ImageSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("ImageDisplayComponent", (value, schema) => {
    const { maxHeight } = schema;
    return react_1.default.createElement(media_1.Image, { style: { backgroundColor: "#fff", maxHeight }, src: value });
});
exports.default = ImageSchemaComponent;
